// ** Icons Import
import {MessageSquare, Truck, UserCheck, DollarSign, Percent} from 'react-feather'

export default [
    {
        header: 'navigation.parking',
        action: 'ROLE_PARKING_',
        resource: 'IS_GRANTED'
    },
    {
        id: 'parking-pylon-message',
        title: 'navigation.pylons',
        icon: <MessageSquare size={20}/>,
        navLink: '/parking/pylon-message',
        action: 'ROLE_PARKING_PYLON_MESSAGE',
        resource: 'IS_GRANTED'
    },
    {
        id: 'parking-white-vehicles',
        title: 'navigation.white_vehicles',
        icon: <Truck size={20}/>,
        navLink: '/parking/white-vehicles',
        action: 'ROLE_PARKING_WHITE_VEHICLES',
        resource: 'IS_GRANTED'
    },
    {
        id: 'parking-price-list',
        title: 'navigation.price_list',
        icon: <DollarSign size={20}/>,
        navLink: '/parking/price-list',
        action: 'ROLE_PARKING_PRICE_LIST',
        resource: 'IS_GRANTED'
    },
    {
        id: 'parking-discount',
        title: 'navigation.discount',
        icon: <Percent size={20}/>,
        navLink: '/parking/discount',
        action: 'ROLE_PARKING_DISCOUNT',
        resource: 'IS_GRANTED'
    },
    {
        id: 'parking-parking-operator',
        title: 'navigation.parking_operator',
        icon: <UserCheck size={20}/>,
        navLink: '/parking/parking-operator',
        action: 'ROLE_PARKING_OPERATOR',
        resource: 'IS_GRANTED'
    }
]